import React, {useEffect} from 'react';
import image1 from './images/1.png';
import image2 from './images/2.png';
import image3 from './images/3.png';
import image4 from './images/4.png';
import image5 from './images/5.png';
import image6 from './images/6.png';
import CourseCatalog from "../components/course-catalog";
import data from '../data';
import PurchaseBar from "../components/purchase-bar";
import styles from './index.module.less';

const SpiderSales = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, []);
  return (
    <div className={styles['sales-page']}>
      <img className={styles.image} src={image1} alt=""/>
      <img className={styles.image} src={image2} alt=""/>
      <img className={styles.image} src={image3} alt=""/>
      <img className={styles.image} src={image4} alt=""/>
      <img className={styles.image} src={image5} alt=""/>
      <CourseCatalog className={styles['course-catalog']} catalogs={data.spiderCatalog} />
      <img className={styles.image} src={image6} alt=""/>
      <PurchaseBar itemId='3' subItemId='3' price='99' rawPrice='199' />
    </div>
  );
};

export default SpiderSales;
